import { usePageNumberFromUrl, usePerPageValueFromUrl, useSortValueFromUrl } from 'idsk-react-components';
import { SortDirectionEnum } from 'elegislativa-frontend-ts-axios';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import {
  fetchNotifikaciaHistoriaList,
} from '../../../../client/admin/external/notifikaciaHistoriaListClient';
import { defaultPerPageValue, perPageDataArray } from '../../../../constants/PaginationPerPageConstants';
import NotifikaciaHistoriaPage from '../../../../model/notifikacia/NotifikaciaHistoriaPage';
import Uuid from '../../../../model/Uuid';

interface ReturnType {
  notifikaciaHistoriaPage: NotifikaciaHistoriaPage;
  notifikaciaHistoriaStatus: ClientStatus;
  reloadNotifikaciaHistoria: () => void;
}

const getSortDirection = (sort): SortDirectionEnum => (sort[1] === 'asc'
  ? SortDirectionEnum.Asc
  : SortDirectionEnum.Desc);

export default (materialUuid: Uuid): ReturnType => {
  const { page } = usePageNumberFromUrl();
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const { sort } = useSortValueFromUrl();

  const {
    data: notifikaciaHistoriaPage,
    status: requestStatus,
    refetch: reloadNotifikaciaHistoria,
  } = useClientFetch(
    fetchNotifikaciaHistoriaList,
    [materialUuid, page, perPageValue, 'datumOdoslania', getSortDirection(sort)],
    [materialUuid, page, perPageValue, sort[0], sort[1]],
  );

  return {
    notifikaciaHistoriaPage,
    notifikaciaHistoriaStatus: requestStatus,
    reloadNotifikaciaHistoria,
  };
};
